import axios from "axios";

export interface ITestAnswerClient {
  saveTestAnswer: SaveTestAnswer[];
}
interface SaveTestAnswer {
  _id: string;
  summary: Summary[];
  evaluation: Evaluation[];
  birthday: string;
  userId: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}
interface Summary {
  title: string;
  value: string;
  _id: string;
}

interface Evaluation {
  title: string;
  value: string;
  _id: string;
}
export const getTestAnswer = async (userId?: string) => {
  return axios
    .get<ITestAnswerClient>(
      `${process.env.REACT_APP_API_URL}/evaluations-answers/${userId}`,
      {
        withCredentials: true,
      }
    )
    .then((response) => response.data);
};
